module.exports = __webpack_public_path__ + "media/country_flags/se-015731dd.png";